import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_monaco_editor = _resolveComponent("g-monaco-editor");
    const _component_g_field_block = _resolveComponent("g-field-block");
    return (_openBlock(), _createBlock(_component_g_field_block, _mergeProps(_ctx.$attrs, {
        name: _ctx.dataMember,
        "is-auto-fill": _ctx.isAutoFill,
        "error-message": _ctx.errorMessage,
        label: _ctx.label
    }), {
        "g-field-input": _withCtx(({ identification, error, disabled, size, setFocusClass, removeFocusClass, hasSuffix, hasPrefix }) => [
            _createVNode(_component_g_monaco_editor, _mergeProps(_ctx.inputAttr, {
                modelValue: _ctx.internalValue,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.internalValue) = $event))
            }), null, 16, ["modelValue"])
        ]),
        _: 1
    }, 16, ["name", "is-auto-fill", "error-message", "label"]));
}
